import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const userApi = {
  info() {
    return http.get(API_URLS.USER_INFO, {
      formatter(data) {
        data.isMain = data.parentId === 0;
        data.isSub = !data.isMain;
        return data;
      },
    });
  },
  logout() {
    return http.post(API_URLS.USER_LOGOUT, {});
  },
  getPreference() {
    return http.get(API_URLS.USER_PREFERENCE, {});
  },
  modifyPreference(params) {
    return http.post(API_URLS.USER_PREFERENCE, {params});
  },
  getTasks() {
    return http.get(API_URLS.GET_TASKS, {});
  },
  getTag(query = {}) {
    return http.get(API_URLS.USER_TAG, {query});
  },
  updateProfile(params) {
    return http.post(API_URLS.UPDATE_PROFILE, {
      params,
      formatter(data) {
        data.isMain = data.parentId === 0;
        data.isSub = !data.isMain;
        return data;
      },
    });
  },
  getTradeFeeRate(quoteCurrencyList) {
    return http.get(API_URLS.TRADING_FEE_RATE, {query: {quoteCurrencyList}});
  },
  getMemberIsPremium() {
    return http.get(API_URLS.MEMBER_IS_PREMIUM, {});
  },
  getMemberStage() {
    return http.get(API_URLS.MEMBER_STAGE, {});
  },
  getFavoriteList() {
    return http.get(API_URLS.FAVORITES_LIST, {});
  },
  addFavorite(params) {
    return http.post(API_URLS.OPERATE_FAVORITE, {params});
  },
  addFavoriteForContract(params) {
    return http.post(API_URLS.OPERATE_FAVORITE_CONTRACT, {params});
  },
  updateContractFavoriteOrder(params) {
    return http.put(API_URLS.CONTRACT_OPERATE_FAVORITE, {params});
  },
  delFavorite(params) {
    return http.delete(API_URLS.OPERATE_FAVORITE, params);
  },
  getFavoriteMerge() {
    return http.get(API_URLS.FAVORITES_MERGE, {});
  },
  favoriteMerge(params) {
    return http.post(API_URLS.FAVORITES_MERGE, {params});
  },
  getDocumentTypesByCountry(country) {
    return http.get(API_URLS.KYC_COUNTRY_DOCUMENT_TYPES, {
      query: {country},
    });
  },
  getUserBasicKycInfo() {
    return http.get(API_URLS.KYC_BASIC_INFO, {});
  },
  setBasicKycInfo(params) {
    return http.post(API_URLS.KYC_BASIC_SUBMIT, {params});
  },
  getCountries() {
    return http.get(API_URLS.KYC_COUNTRIES, {});
  },
  getBaseKycCheck() {
    return http.get(API_URLS.BASE_KYC_CHECK, {});
  },
  getBonus() {
    return http.get(API_URLS.GET_BONUS, {});
  },
  getUserMemberLevel() {
    return http.get(API_URLS.USER_MEMBER_LEVEL, {});
  },
  getRecommend(query) {
    return http.get(API_URLS.WEB_RECOMMEND, {query});
  },
  getPublicGeoV2() {
    return http.get(API_URLS.PUBLIC_GEO_V2, {});
  },
  customizeBiz(params) {
    return http.post(API_URLS.CUSTOMIZE_BIZ, {params});
  },
  customizeQuery() {
    return http.get(API_URLS.CUSTOMIZE_QUERY, {});
  },
  getUserBizGray() {
    return http.get(API_URLS.ACCOUNT_BIZ_GRAY, {});
  },
  getUtaInfo() {
    return http.get(API_URLS.UTA_QUERY, {});
  },
  postUtaSpotUpgradeAnswerCompleted() {
    return http.post(API_URLS.UTA_SPOT_UPGRADE_ANSWER_COMPLETED, {});
  },
  postUtaSpotUpgradeApply() {
    return http.post(API_URLS.UTA_SPOT_UPGRADE_APPLY, {});
  },
  getUtaSpotUpgradeCheckSub() {
    return http.get(API_URLS.UTA_SPOT_UPGRADE_CHECK_SUB, {});
  },
  postUtaSpotUpgradeApplySub(query) {
    return http.post(API_URLS.UTA_SPOT_UPGRADE_APPLY_SUB, {query});
  },
  switchContractPtDiscount(query) {
    return http.post(API_URLS.CONTRACT_PT_DISCOUNT, {query});
  },
  switchSpotPtDiscount(params) {
    // params.walletType: SPOT，Margin, UTA
    // params.kickOff: 0：关闭，1：打开
    return http.post(API_URLS.SPOT_PT_DISCOUNT, {params});
  },
  getUserProfile() {
    return http.get(API_URLS.USER_PROFILE_META, {});
  },
};
